import {useCallback, useState} from 'react';
import validateHelper from 'validate.js';

export interface ValidationErrors {
  [key: string]: string[];
}

export interface Rules extends Record<string, any> {}

interface ValidationOptions {
  rules: Rules;
}

export function useInput<T extends Record<string, any>>(
  initialState: T = {} as T,
  validationOptions?: ValidationOptions,
) {
  const [inputs, setInputsLocal] = useState<T>(initialState);
  const [errors, setErrors] = useState<ValidationErrors>();

  const handleInputChange = useCallback((data: Record<string, any> = {}) => {
    if (!data.page && !data.limit) {
      data.page = 1;
      data.limit = 30;
    }
    setInputsLocal(i => ({...i, ...data}));
  }, []);

  const resetInput = () => {
    setInputsLocal(initialState);
  };

  const trimSpaces = (text?: string) => {
    if (!text) {
      return '';
    }
    return text.replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
  };

  const trimSpacesOnChange = (text?: string) => {
    if (!text) {
      return '';
    }
    return text.replace(/^\s+|\s+$/g, ' ').replace(/\s+/g, ' ');
  };

  const getErrors = (): ValidationErrors | undefined => {
    const rules = validationOptions?.rules;
    if (!rules) {
      return undefined;
    }
    validateHelper.validators.presence.options = {allowEmpty: false};
    const validationErrors = validateHelper.validate(inputs, rules);
    setErrors(validationErrors);
    return validationErrors;
  };

  return {
    validation: {
      getErrors,
      errors,
    },
    setInputs: handleInputChange,
    inputs,
    resetInput,
    trimSpaces,
    trimSpacesOnChange,
  };
}
